module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui container view"
  }, [_c('div', {
    staticClass: "ui two column centered grid"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "ui raised segment"
  }, [_c('h3', [_vm._v("Create a New Quote")]), _vm._v(" "), (_vm.flashIsActive) ? _c('div', {
    staticClass: "ui message",
    class: _vm.flash.type
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n            " + _vm._s(_vm._f("capitalize")(_vm.flash.type)) + "\n          ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.flash.message))])]) : _c('div', [_c('p', [_vm._v("Use one of the templates below as a starting point for your new quote.")]), _vm._v(" "), _c('div', {
    staticClass: "ui divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui relaxed divided selection list"
  }, _vm._l((_vm.quoteTemplates), function(quoteTemplate) {
    return _c('a', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.loadQuote(quoteTemplate)
        }
      }
    }, [_c('i', {
      staticClass: "large file text middle aligned icon"
    }), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "ui tiny blue header"
    }, [_vm._v(_vm._s(quoteTemplate.title))]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(quoteTemplate.description))])])])
  }))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5a131294!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/New.vue
// module id = 222
// module chunks = 2